module.exports = __webpack_public_path__ + "static/media/prefettura-di-reggio-emilia.11beea1a.svg";